import type { Icon } from '../../../src/lib/types'
export const mdiAlert: Icon = {
  "id": "alert",
  "name": "Alert",
  "path": "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z",
  "as": [
    "warning",
    "report-problem"
  ],
  "tags": [
    "Alert / Error"
  ]
}
export default mdiAlert